import { services } from '../services';
var action = "commission";

export const commissionService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    getPay,
    pay,
    log,
    finish,
    changeDate,
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function getPay(id) {
    return services.restApi(`${action}/getpay/${id}`, 'GET');
}

function pay(object) {
    return services.restApi(`${action}/pay`, 'POST', object);
}

function log(id) {
    return services.restApi(`${action}/pay/log/${id}`, 'get');
}

function finish(id) {
    return services.restApi(`${action}/finish/${id}`, 'get');
}

function changeDate(object) {
    return services.restApi(`${action}/date`, 'POST', object);
}